import React from "react";
import Clickable from "shared/components/oknf/_Clickable";

const OkRadio = (props) => (
	<Clickable {...props} type="radio" />
);

export default OkRadio;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/OkRadio.jsx